import React, { DetailedHTMLFactory, TextareaHTMLAttributes } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface IScriptTextAreaHookForm {
  secondDiv: string;
  className: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  register: UseFormRegisterReturn;
  rows?: number;
  readOnly?: boolean;
}
const ScriptTextAreaHookForm: React.FC<IScriptTextAreaHookForm> = ({
  secondDiv = "md:grid-cols-2",
  className = "border border-gray-300 focus:ring-septenary focus:border-septenary",
  label,
  required = false,
  disabled = false,
  register,
  rows,
  readOnly = false,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`grid ${secondDiv} w-full items-center gap-2`}>
        {label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {required && <span className="text-red-500 pl-1 font-bold">*</span>}
            {label}:{""}
          </label>
        )}
        <textarea
          className={`block w-full h-100 bg-white bg-clip-padding leading-normal outline-none
            px-1 py-1 text-xs sm:text-xs rounded-sm ${className} ${
            disabled && "opacity-50"
          }`}
          rows={rows}
          readOnly={readOnly}
          {...register}
          {...props}
        />
      </div>
    </div>
  );
};

export default ScriptTextAreaHookForm;
